import type { InvitedAppShortcutsRecommendationsQuery$variables } from './__generated__/InvitedAppShortcutsRecommendationsQuery.graphql.ts';

/**
 * Single source of truth for the Invited App Shortcuts GRS recommendations query variables, shared
 * by the SSR preloader (`preloadInvitedAppShortcutsRecommendationsQuery`) and the render-time
 * consumer (`InvitedAppShortcutsRecommendations`).
 *
 * These MUST be identical between preload and consume, otherwise the client's `store-or-network`
 * lookup misses the SSR-seeded record and refetches. Keeping one builder (typed to the generated
 * query's `$variables`) makes that invariant structural rather than a comment.
 *
 * No `rerank`: GRS derives the candidate products itself from `context.product`
 * (host `confluence` → recommends `jira`), so the client no longer nominates
 * them. Sending it would actively break the feature — `filterRerank` does an
 * exact `entityId` match, which cannot match the variant-encoded ids GRS emits
 * since PUMA-2245.
 */
export const buildInvitedAppShortcutsRecommendationsVariables = (
	cloudId: string,
): InvitedAppShortcutsRecommendationsQuery$variables => ({
	tenantId: cloudId,
	product: 'confluence',
});
